import { render } from "./AdminEstateMapCreate.vue?vue&type=template&id=c2484abe&scoped=true&ts=true&lang=pug"
import script from "./AdminEstateMapCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminEstateMapCreate.vue?vue&type=script&lang=ts&setup=true"

import "./AdminEstateMapCreate.vue?vue&type=style&index=0&id=c2484abe&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2484abe"]])

export default __exports__